// src/components/Configurator/renderers/SwitchDoubleRenderer.jsx
import React from "react";
import { SELECTED_ELEMENT_COLOR, defaultObjectSizes, OBJECT_TYPES } from "../configuratorConstants";
import { ReactComponent as SwitchX2Svg } from '../../Assets/switchx2.svg';

const SwitchDoubleRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness, // in meters
  placementSideFactor, // Should be 1 or -1
}) => {
  const switchDefaults = defaultObjectSizes[OBJECT_TYPES.SWITCH_DOUBLE];
  // Для поворота на 90 градусов, визуальная ширина станет высотой и наоборот
  const elementVisualWidthM_orig = element.width || switchDefaults.width;
  const elementVisualHeightM_orig = element.height || switchDefaults.height;
  const elementDepthM = element.depth || switchDefaults.depth || 0.01;

  // Размеры SVG компонента после внутреннего поворота на 90 градусов
  const elementVisualWidthPx = elementVisualHeightM_orig * scale; // Бывшая высота становится шириной
  const elementVisualHeightPx = elementVisualWidthM_orig * scale; // Бывшая ширина становится высотой

  const wallThicknessPx = wallThickness * scale;
  const elementDepthPx = elementDepthM * scale;

  const yOffset = placementSideFactor * ( (wallThicknessPx / 2) + (elementDepthPx / 2) );
  


  // Отражение, если элемент на "положительной" стороне стены
  const flipTransform = placementSideFactor === 1 ? "scale(1, -1)" : "";
  // Поворот самого SVG на 90 градусов по часовой стрелке
  const rotateTransform = "rotate(180)";
  
  // Сначала поворачиваем SVG, затем отражаем, если нужно
  const combinedSvgTransform = `${rotateTransform} ${flipTransform}`;

  return (
    <g transform={`translate(0, ${yOffset})`}>
      {/* Группа для комбинированного поворота и отражения */}
      <g transform={combinedSvgTransform}>
        <SwitchX2Svg
          // Центрируем SVG относительно его новых, повернутых размеров
         x={-elementVisualWidthPx / 2} 
          y={-elementVisualHeightPx / 3}
          width={elementVisualWidthPx / 0.9}
          height={elementVisualHeightPx} // Используем повернутые размеры
          preserveAspectRatio="xMidYMid meet"
        />
      </g>
    </g>
  );
};

export default React.memo(SwitchDoubleRenderer);  